import type { FaireProductEntity } from "../../entity_types/product";

export const p_cmmmbhr9mb: FaireProductEntity = {
  token: "p_cmmmbhr9mb",
  type: "product",
  name: "Hollow Flower 18K Gold Plated S.Steel Huggie Earrings - FGS",
  brandToken: "b_nex9pcmkzj",
  brandName: "Mio Queena",
  imageUrl:
    "https://cdn.faire.com/fastly/7e9a5a0a60cd94fa4d5121b1b5c26ebe391a1af5d8fe4d202af192f0f022af40.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/61f08fd14f8abed2f4aa14e2b85982104194e197b65ba990088b227a62ed7f3d.jpeg",
    "https://cdn.faire.com/fastly/2c2fc67f2700d945a65fbb8cb13edc463e43c78464b53d8f51a508da6af5d04f.jpeg",
    "https://cdn.faire.com/fastly/a530daf15daf971cb0eaa724d8b2368a3e62392a32f5f1042f7bee2f25a8f585.jpeg",
  ],
  priceDollars: 7.11,
  description:
    "Type: Earrings\nMaterial : Stainless steel ,18K gold plated\nSize :24mm*35mm\nProcess: Vacuum electroplating and manual polishing,Non tarnish\nSurface : High Polish\n★Made of high quality stainless steel,Lead-free,Harmless to Human Body.\n★Perfect jewelry gifts ",
  tags: [],
  msrpDollars: 19.86,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:01:40.283Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
